import React, { Component } from 'react';
import "./pageView.css";
import "./pageView_mb.css";
import Slider from 'react-slick';
import QRCode from 'qrcode';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
import { CSSTransition } from "react-transition-group";
import 'swiper/css';
class PageView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loginNav:true,
            sceneName:'scene_001',
            coverNav:true,
            class1:"",
            sceneNav:false,
            hotNav:false,
            musicNav:true,
            shareNav: false,
            shareType: 0,
            addressNav:false,
            dayNav:true,
            hotName:"",
            hotDetail:"",ready1:false,hLookat:0,flootIndex:-1,aboutNav:false,
            isCanPlay:false,isLookDom:false,isPlay:false
        };
        this.krpano=undefined;
        this.krpanoSmall=undefined;
        this.slider=null;
        this.isMouseDown=false;
        this.mousepos = {x:0,y:0};
        this.mousepos1 = {x:0,y:0};
        this.tween1 = null;
        
        this.musicRef1 = React.createRef();
        this.soundRef = React.createRef();
        this.musicRef = React.createRef();
        this.qrRef = React.createRef();
        this.qrLinkRef = React.createRef();
        this.sceneArr = {

        }
        this.sceneClass={

        }
        this.soundPos = {
            ath:0,
            atv:0
        };
        this.pwd = "9999"
       
    };
   
    
    componentDidMount() {
        if (!this.krpano) {
       
            this.krpano= {}
            this.initKrpano()
             window.sceneload =  this.sceneload.bind(this)
            window.krpanoClick = this.krpanoClick.bind(this)
            window.onviewchange = this.onviewchange.bind(this)
            
            window.readyAddScene =  this.readyAddScene.bind(this)
            window.changenav =  this.changenav.bind(this)
            
            var fun = (doc, win) => {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = () => {
                        var clientWidth = docEl.clientWidth;
                        if (!clientWidth) return;
                        docEl.style.fontSize = ((clientWidth / 70) < 12 ? 12 : (clientWidth / 70)) + 'px';
                    };
                if (!doc.addEventListener) return;
                win.addEventListener(resizeEvt, recalc, false);
                doc.addEventListener('DOMContentLoaded', recalc, false);
                recalc()
            }
            fun(document, window)
            setTimeout(() => this.setState({ready1 : true}), 50);
            this.musicRef1.current.addEventListener('ended',()=>{
                this.setState({isPlay : false})
            })
            axios.get("./config.json?"+new Date().getTime()).then((val)=>{
                this.pwd = val.data.password
            })
        }
    }
    componentWillUnmount () {
    }
   
    initKrpano = config => {
        let _this = this;

        window.embedpano({
            xml: "./pano/tour.xml",
            target: "pano",
            bgcolor: "#222222",
            html5: "webgl+only",
            mobilescale: 1.0,
            consolelog: true,
            passQueryParameters: true,
            onready: function(jsapi) {
                _this.krpano = jsapi.get("global");
                window.krpano = _this.krpano
                  const params = new URLSearchParams(window.location.search);
                if (params.get('l')) {
                    this.krpano.call(`loadtopano(${params.get('l')})`)
                }
                this.jynav =  JSON.parse(JSON.stringify(window.krpano.jynav));
            }
        });
         window.embedpano({
            xml: "./pano/model.xml",
            target: "krpanoModel",
            bgcolor: "transparent",
            html5: "webgl+only",
            mobilescale: 1.0,
            consolelog: true,
            passQueryParameters: true,
            onready: (jsapi) =>{
                this.krpanoSmall = jsapi.get("global");
                window.krpanoSmall = this.krpanoSmall
                // this.krpanoSmall.call('loadscene(scene_model3d1,null,MERGE,BLEND(0.5));');
            }
        });
    }
    updateCamera = ()=>{
        
    }
   
    sceneload = ()  =>{
        this.setState({
            sceneName:this.krpano.xml.scene,
            flootIndex:this.krpano.get('scene').getArray().find(val => val.name == this.krpano.xml.scene).fl,
            addressNav:false
        },()=>{
            console.log(this.state.sceneName)
            console.log(this.state.flootIndex)


            if(this.state.flootIndex){
                if(this.state.dayNav){
                    if('scene_model3d' + this.state.flootIndex +'-1' != this.krpanoSmall.xml.scene){
                        this.krpanoSmall.call(`loadscene(scene_model3d${this.state.flootIndex}-1,null,MERGE,BLEND(0.5));`);
                    }
                }else{
                    if('scene_model3d' + this.state.flootIndex != this.krpanoSmall.xml.scene){
                            this.krpanoSmall.call(`loadscene(scene_model3d${this.state.flootIndex},null,MERGE,BLEND(0.5));`);
                    }
                }
               
            }else{
                if(this.state.dayNav){
                    if('scene_model3d5-1'!= this.krpanoSmall.xml.scene){
                        this.krpanoSmall.call(`loadscene(scene_model3d5-1,null,MERGE,BLEND(0.5));`);
                    }
                }else{
                    if('scene_model3d5'!= this.krpanoSmall.xml.scene){
                   
                        this.krpanoSmall.call(`loadscene(scene_model3d5,null,MERGE,BLEND(0.5));`);
                    }
                }
            }

            
        })
        let array = []
        this.krpano.get('hotspot').getArray().map((val,inx)=>{
            array.push(val)
        })


        array.map((val,inx)=>{
             if(val.style == 'floorspot'){
                val.remove()
            }else if(val.name.indexOf('vrtooltip_')>-1){
                val.remove()
            }
        })

        this.krpano.jynav.forEach((item,index,self)=>{
            if(item[0][1] == window.krpano.xml.scene){
                item[1].forEach((item1,index1,self1)=>{
                    this.addFloot(item1)
                    // this.krpano.call('add_plane_hotspot(' + item1 + ');')
                })
                this.addFloot(window.krpano.xml.scene.substring(6))
                // this.krpano.call('add_plane_hotspot(' + window.krpano.xml.scene.substring(6) + ');')
            }
        })
        if(this.krpano.xml.scene == 'scene_sky'){
            let hot = this.krpano.actions.addhotspot("floorspot_link1")
            hot.loadstyle("plane_tip")
            hot.ath = -10
            hot.atv = 50
            hot.rotate=8
            hot.url = './image/Day.png'
            hot.onclick='linkpano1()'

            let hot1 = this.krpano.actions.addhotspot("floorspot_link2")
            hot1.loadstyle("plane_tip")
            hot1.ath = 10
            hot1.atv = 50
            hot1.rotate=-8
            hot1.url = './image/night.png'
            hot1.onclick='linkpano()'
            this.setState({
                coverNav:true,
                musicNav:true
            })
            this.musicRef.current.pause()
        }else{
            if(this.state.musicNav){
                this.musicRef.current.play()
            }
            this.setState({
                coverNav:false
            })
            if(this.krpano.xml.scene.substring(0,13) !== 'scene_model3d'){
                if(parseInt(this.krpano.xml.scene.substring(6)) > 300 && parseInt(this.krpano.xml.scene.substring(6)) < 700){
                    this.setState({
                        dayNav:true
                    })
                }else{
                    this.setState({
                        dayNav:false
                    })
                }
            }
            
        }
        if(this.krpano.xml.scene == 'scene_702'){
            this.soundPos.ath =180;
            this.soundPos.atv =0;
            this.setState({
                isCanPlay:true,
                isLookDom:false,
                isShowSound:true,
                isPlay:!this.musicRef1.current.paused,
            })
        }else if(this.krpano.xml.scene == 'scene_703'){
            this.soundPos.ath =180;
            this.soundPos.atv =0;
            this.setState({
                isCanPlay:true,
                isLookDom:false,
                isShowSound:true,
                isPlay:!this.musicRef1.current.paused,
            })
        }else if(this.krpano.xml.scene == 'scene_705'){
            this.soundPos.ath =-90;
            this.soundPos.atv =7;
            this.setState({
                isCanPlay:true,
                isLookDom:false,
                isShowSound:true,
                isPlay:!this.musicRef1.current.paused,
            })
        }else{
            this.setState({
                isCanPlay:false,
                isLookDom:false,
                isShowSound:true,
                isPlay:!this.musicRef1.current.paused,
            })
        }

    }
   
    onviewchange = () => {
        this.setState({hLookat:this.krpano.view.hlookat - 90 - 45})
        if(this.krpano && this.krpanoSmall){
            this.krpanoSmall.view.hlookat = this.krpano.view.hlookat
            this.krpanoSmall.view.vlookat = this.krpano.view.vlookat + 45
            this.krpanoSmall.view.fov = this.krpano.view.fov
            this.krpanoSmall.view.tx = this.krpano.view.tx
            this.krpanoSmall.view.ty = this.krpano.view.ty
            this.krpanoSmall.view.tz = this.krpano.view.tz
        }


        if(this.state.isCanPlay){
            let a = this.krpano.spheretoscreen(this.soundPos.ath,this.soundPos.atv)
            this.soundRef.current.style.left = a.x + 'px'
            this.soundRef.current.style.top = a.y + 'px'
            if(a.x > 0 && a.x<window.innerWidth && a.y >0 && a.y<window.innerHeight){
                if(this.state.isLookDom == false){
                    this.setState({
                        isLookDom:true
                    })
                }
            }else{
                if(this.state.isLookDom){
                    this.setState({
                        isLookDom:false
                    })
                }
            }
        }
        
    }
    readyAddScene = ()  =>{
        if(this.sceneArr.length > 1){
            return
        }
        this.sceneArr = this.krpano.get('scene').getArray()
    }
    addressFun = () => () =>{
        this.setState({
            addressNav:!this.state.addressNav
        },()=>{
            if(this.state.addressNav){
                this.lastScene = this.krpano.xml.scene
                let tx = this.krpano.view.tx;
                let ty = this.krpano.view.ty;
                let tz = this.krpano.view.tz;
                this.krpano.call('stoptween(view.oz);');
                this.krpano.actions.loadscene(this.krpanoSmall.xml.scene,null,'MERGE|KEEPVIEW|KEEPHOTSPOTS','BLEND(1.6,easeinoutcubic)',()=>{}) 
                this.krpano.set('control.invert', true);
                this.krpano.set('view.tx', tx);
                this.krpano.set('view.ty', ty);
                this.krpano.set('view.tz', tz);

                this.krpano.call(`tween(view.tx|view.ty|view.tz|view.ox|view.oy|view.oz|view.fisheye,
                    calc('${tx}|${ty}|${tz}|0|0|${this.state.flootIndex == 4 ? 3000:2000}|0'),
                    1.5,
                    default,
                );`)
                this.krpano.set('view.vlookat', 45);
                this.addressLoad()
            }else{
                this.krpano.call(`flytopano(${this.lastScene})`)
             
            }
            

            
         
                
        })

    }

    krpanoClick = ()  =>{
        var hit = this.krpano.actions.screentodepth(this.krpano.mouse.x, this.krpano.mouse.y);
        console.log(hit)	

        var str = `"tx":"${hit.x.toFixed(2)}","ty":"${hit.y.toFixed(2)}","tz":"${hit.z.toFixed(2)}"`
        // navigator.clipboard?.writeText(str)
        if(this.krpano.xml.scene.substring(0,13) !== 'scene_model3d'){
            return
        }
        if((this.krpano.mouse.x < window.innerWidth * 0.65 && this.krpano.mouse.x > window.innerWidth * 0.35) &&
            (this.krpano.mouse.y < window.innerHeight * 0.65 && this.krpano.mouse.y > window.innerHeight * 0.35)
            ){
            let name = '',distance =Infinity;
            this.krpano.jynav.forEach((item,index,self)=>{
                const dx = item[2][0] - hit.x, dy = item[2][1] - hit.y, dz = item[2][2] - hit.z;
                const dist = dx * dx + dy * dy + dz * dz
                if(this.state.dayNav && parseInt(item[0][1].substring(6)) > 300 && parseInt(item[0][1].substring(6)) < 700){
                    if (distance > dist) {
                        name = item[0][1]
                        distance = dist
                    }
                }else if(!this.state.dayNav && (parseInt(item[0][1].substring(6)) < 300 || parseInt(item[0][1].substring(6)) > 700)){
                    if (distance > dist) {
                        name = item[0][1]
                        distance = dist
                    }
                }
            })
             this.setState({
                addressNav:false
            })
            this.sceneclick(name)
            this.krpano.call('lookto(' + this.krpano.get('view.hlookat') + ',' + 0 + ')')
        }else{
            if(!hit){
                return
            }
            this.krpano.call('tween(view.tx|view.ty|view.tz,'+hit.x+'|' +hit.y + '|' +hit.z+ ',1.5,default);');
        }

	}	
    sceneclick(name){

        this.krpano.call('stoptween(view.tx);');
        this.krpano.call('stoptween(view.ty);');
        this.krpano.call('stoptween(view.tz);');
      
        this.krpano.call('flytopano(' +  name +')')
        
    }
    flootFun = (val) => () =>{
        this.setState({
            flootIndex:val
        },()=>{
            let scene = 'scene_model3d'+ val

            let tx = this.krpano.view.tx;
            let ty = this.krpano.view.ty;
            let tz = this.krpano.view.tz;
            let oz = 1500;
            let hlookat = 90;
            if(val == 1 ){
                tx = -258.56035120481806;
                ty = 0;
                tz = 705.489303731383;
                oz = 2000;
            }else if(val == 2){
                tx = -259.8837291878094;
                ty = -228.05204299533995;
                tz = 1114.751265868811;
                oz = 2000;
            }else if(val == 3){
                tx = -306.2243340988746;
                ty = -494.1350533699639;
                tz = 1239.0551303480213;
                oz = 2000;
            }else if(val == 4){
                tx = -1701.3450335322661;
                ty = 1439.5371444091795;
                tz = 862.7575602495413;
                oz = 3000;
            }else if(val == 5 ){
                tx = -193.2033223436241;
                ty = 282.8372367553711;
                tz = 1062.5920699545723;
                oz = 4000;
            }
            this.krpano.call('stoptween(view.oz,view.tx,view.ty,view.tz);');
            if(this.state.dayNav){
                scene += '-1'
            }
            this.krpano.actions.loadscene(scene ,null,'MERGE|KEEPVIEW|KEEPHOTSPOTS','BLEND(1.6,easeinoutcubic)',()=>{}) 
            this.krpano.set('control.invert', true);
            this.krpano.set('view.tx', tx);
            this.krpano.set('view.ty', ty);
            this.krpano.set('view.tz', tz);
            this.krpano.set('view.oz', oz);
            this.krpano.set('view.vlookat', 45);
            this.krpano.set('view.hlookat', hlookat);
            this.addressLoad()
        })
    }
    addressLoad = ()  =>{
        let array = []
        this.krpano.get('hotspot').getArray().map((val,inx)=>{
            array.push(val)
        })
        array.map((val,inx)=>{
            
             if(val.style == 'floorspot'){
                val.remove()
            }else if(val.name.indexOf('vrtooltip_')>-1){
                val.remove()
            }
        })
        
        this.krpano.get('scene').getArray().map((val)=>{
            if(this.state.dayNav && parseInt(val.name.substring(6)) > 300 && parseInt(val.name.substring(6)) < 700){
                if(val.fl == this.state.flootIndex){
                    // this.krpano.call('add_plane_hotspot(' + val.name.substring(6) + ');')
                    this.addFloot(val.name.substring(6))
                }else if(this.state.flootIndex == 5 && (val.fl == 1 || val.fl == 2 || val.fl == 3)){
                    // this.krpano.call('add_plane_hotspot(' + val.name.substring(6) + ');')
                    this.addFloot(val.name.substring(6))
                }
            }else if(!this.state.dayNav && (parseInt(val.name.substring(6)) < 300 || parseInt(val.name.substring(6)) > 700)){
                if(val.fl == this.state.flootIndex){
                    // this.krpano.call('add_plane_hotspot(' + val.name.substring(6) + ');')
                    this.addFloot(val.name.substring(6))
                }else if(this.state.flootIndex == 5 && (val.fl == 1 || val.fl == 2 || val.fl == 3)){
                    // this.krpano.call('add_plane_hotspot(' + val.name.substring(6) + ');')
                    this.addFloot(val.name.substring(6))
                }
            }
        })
    }
    addFloot(spotid){
        let hot = this.krpano.actions.addhotspot('floorspot_' + spotid)
        let style = this.krpano.get(`style[jypano_${spotid}]`)
        hot.loadstyle('floorspot')
        hot.tx = parseFloat(style.ox)
        hot.ty = parseFloat(style.oy) + parseFloat(style.oh) - 1
        hot.tz = parseFloat(style.oz)
        hot.linkedscene =  style.linkedscene
        hot.visible = true
        setTimeout(() => {
            this.addFloot1(spotid)
        }, 200);
     
    }
    addFloot1(spotid){
        let hot = this.krpano.get(`hotspot[floorspot_${spotid}]`)
        let style = this.krpano.get(`style[jypano_${spotid}]`)
        if(style.lock){
            hot.depthbuffer = false
            return
        }
        let hit = this.krpano.actions.raycast(
            parseFloat(style.ox), parseFloat(style.oy), parseFloat(style.oz),
            0, 1, 0
        );
        if(hit){
            hot.tx = hit.x
            hot.ty = hit.y - 1
            hot.tz = hit.z
        }
        hot.visible = true
    }
    musicFun = (val) => (event) => {
        this.setState({
            musicNav:!this.state.musicNav
        },()=>{
            if(this.state.musicNav){
                this.musicRef.current.play()
            }else{
                this.musicRef.current.pause()
            }
        })
    }
    fullFun = () => (event) => {
        this.setState({
            fullNav: !this.state.fullNav,
        },function (){
            if(this.state.fullNav){
                this.fullScreen()
            }else{
                this.exitFullscreen()
            }
        });
    }
     fullScreen() {
        var de = document.documentElement;
          if (de.requestFullscreen) {
              de.requestFullscreen();
          } else if (de.mozRequestFullScreen) {
              de.mozRequestFullScreen();
          } else if (de.webkitRequestFullScreen) {
              de.webkitRequestFullScreen();
          }
    }
    exitFullscreen() {
        if(document.exitFullscreen) {
             document.exitFullscreen();
         } else if(document.mozCancelFullScreen) {
             document.mozCancelFullScreen();
         } else if(document.webkitExitFullscreen) {
             document.webkitExitFullscreen();
         }
    }
    shareFun = () => () => {
        this.setState({
            shareNav: !this.state.shareNav,
            shareType: 0
        }, () => {
            if (this.state.shareNav) {
                const text = window.location.href + `?l=${this.krpano.xml.scene}`;

                QRCode.toDataURL(text, { width: 200 })
                    .then(url => {
                        this.qrRef.current.src = url
                        this.qrLinkRef.current.value = text
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        })
    }
     shareTypeFun = (index) => () => {
        this.setState({
            shareType: index
        }, () => {
            let text = window.location.href;
            if (this.state.shareType == 0) {
                text += `?l=${this.krpano.xml.scene}`
            }
            QRCode.toDataURL(text, { width: 200 })
                .then(url => {
                    this.qrRef.current.src = url
                    this.qrLinkRef.current.value = text
                })
                .catch(err => {
                    console.error(err);
                });
        })
    }
    shareCopyFun = (val) => () => {

        navigator.clipboard.writeText(this.qrLinkRef.current.value)
        alert('复制成功')
    }
    
    aboutFun = (val) => () => {

        this.setState({
            aboutNav:!this.state.aboutNav
        })
    }
    dayFun= (val) => () => {
        this.setState({
            dayNav:!this.state.dayNav
        },()=>{
            if(this.state.musicNav){
                this.musicRef.current.volume = 0.5
                this.musicRef.current.play()
            }
            this.krpano.call('stoptween(view.oz);');
            this.krpano.set('view.oz',0)
            if(this.state.dayNav){
                
                this.krpano.call('linkpano1()')
            }else{
               
                this.krpano.call('linkpano()')
            }
        })
    }
    loginFun = () => () => {
        const password = document.getElementById("password").value.trim();
        const errorMsg = document.getElementById("errorMsg");
        if(password == this.pwd){
            this.setState({
                loginNav:false
            })
        }else{
            errorMsg.textContent = "Incorrect password";
        }

    }
   
    homeFun= (val) => () => {
        this.setState({
            coverNav:true,musicNav:true
        },()=>{
            this.musicRef.current.pause()
            this.krpano.call('stoptween(view.oz);');
            this.krpano.call('stoptween(view.tx);');
            this.krpano.call('stoptween(view.ty);');
            this.krpano.call('stoptween(view.tz);');
            this.krpano.call('loadscene(scene_sky,null,null,BLEND(1))')
            this.krpano.set('view.tx',0)
            this.krpano.set('view.ty',0)
            this.krpano.set('view.tz',0)
            this.krpano.set('view.oz',0)
        })
    }
    togglepause = () => ()=>{
        this.setState({
            isPlay: !this.state.isPlay,
        },()=>{
            if(this.state.isPlay){
                this.musicRef1.current.play()
                this.playSoundDom = true;

                this.setState({
                    isShowSound: true,
                })
            }else{
                this.playSoundDom = false;
                this.musicRef1.current.pause();
            }
        })
    }
    changenav= (val)  =>{
        console.log(val.substring(20))
    }
    render() {
        return <div className='container' >
            <audio src="./music/别墅录音.mp3" ref={this.musicRef1}  loop={false}></audio>
            <audio src={this.state.dayNav ? "./music/日景.mp3":"./music/夜景.mp3"} ref={this.musicRef} autoPlay={true} loop={true}></audio>
            <div className='con-krpano container' id="pano"   >
                {
                    !this.state.coverNav ? 
                    <div className='con-tool' >
                        <div class="img-wrap" onClick={this.homeFun()} tips="home">
                            <img src="./image/首页 2.png"/>
                        </div>
                        <div class="img-wrap" onClick={this.dayFun()} tips={this.state.dayNav ? "day":"night"}>
                            <img src={this.state.dayNav ? "./image/夜景.png" : "./image/日景.png"} />
                        </div>
                        <div class="img-wrap" onClick={this.musicFun()} tips="music">
                            <img src="./image/音乐.png" />
                        </div>
                        <div class="img-wrap" onClick={this.fullFun()}  tips="full">
                            <img src="./image/放大.png" />
                        </div>
                    </div>
                    : <div></div>
                }
                 
                <div className='con-address' style={{display:this.state.coverNav?'none':""}} onClick={this.addressFun()} >
                    <div id='krpanoModel'></div>
                    <div className='title'>{this.state.addressNav ? 'back pano':'3D model'}</div>
                </div>
                {this.state.addressNav ? <div className='flbtns'>
                        <div className={this.state.flootIndex == 5 ? 'select':''} onClick={this.flootFun(5)}>ALL</div>
                        <div className={this.state.flootIndex == 3 ? 'select':''} onClick={this.flootFun(3)}>3F</div>
                        <div className={this.state.flootIndex == 2 ? 'select':''} onClick={this.flootFun(2)}>2F</div>
                        <div className={this.state.flootIndex == 1 ? 'select':''} onClick={this.flootFun(1)}>1F</div>
                        <div className={this.state.flootIndex == 4 ? 'select':''} onClick={this.flootFun(4)}>1B</div>
                </div>: <div></div>
                }
                {
                    this.state.shareNav ?
                        <div className="trpm-alert  panoInfo-alert sys-skin3"  >
                            <div className="trpm-bk"></div>
                            <div className="trpm-mc trpm-share" >
                                <div className='line1'>
                                    <span>share</span>
                                    <img src="./image/button_关闭.png" onClick={this.shareFun()} alt="" />
                                </div>
                                <div className='line2 lineShare'>
                                    <div className='line1'>
                                        <div onClick={this.shareTypeFun(0)} className={this.state.shareType == 0 ? 'select' : ''}>this scene</div>
                                        <div onClick={this.shareTypeFun(1)} className={this.state.shareType == 1 ? 'select' : ''}>pano product</div>
                                    </div>
                                    <div className='line2'>
                                        <img ref={this.qrRef} />
                                    </div>
                                    <div className='line3'>
                                        <div>URl</div>
                                        <div className='link'>
                                            <input type='text' ref={this.qrLinkRef} />
                                            <div onClick={this.shareCopyFun()}>copy</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : <div></div>
                }

                  {
                    this.state.aboutNav ?
                        <div className="trpm-alert  panoInfo-alert sys-skin3"  >
                            <div className="trpm-bk"></div>
                            <div className="trpm-mc trpm-share" >
                                <div className='line1'>
                                    <span>detail</span>
                                    <img src="./image/button_关闭.png" onClick={this.aboutFun()} alt="" />
                                </div>
                                <div className='line2 lineShare'>
                                    HESHENG DONGJIAO
                                </div>
                            </div>
                        </div> : <div></div>
                }
                {
                    this.state.loginNav ? 
                    <div class="login-box" >
                        <div class="login" >
                            <h2>Login</h2>
                            <input type="password" id="password" placeholder="password" />
                            <button onClick={this.loginFun()}>Login</button>
                            <div class="error" id="errorMsg"></div>
                        </div>
                    </div> : <div></div>


                }
           
                <div ref={this.soundRef} id='sound-con' style={{display:this.state.isCanPlay && this.state.isLookDom?'block':'none'}} >
                    <div className="item-point"></div>
                    <div className="item-content content-media ">
                        <span className="line-wrap">
                            <span className="slash-line"></span>
                            <span className="straight-line"></span>
                        </span>
                        <div className="audio-box" onClick={this.togglepause()}>
                            <span className="title_txt txtFadeTop">
                                <span className="icon-scale-wrap">
                                    <i  className={this.state.isPlay ? 'cm-icon play' : 'cm-icon paused'}></i>
                                </span>
                                <span className="text">Greetings</span>
                            </span>
                        </div>
                    </div>
                </div> 

            </div>
        </div>
    }
}


export default PageView;
